import { bulkDeleteHandlers } from './trackers/bulkDelete';
import { bulkRestoreHandlers } from './trackers/bulkRestore';
import { importHandlers } from './trackers/import';
import { exportHandlers } from './trackers/export';

/**
 * Base map of realtime notification handlers, keyed by notification `type`.
 * Apps extend this with their own handlers (webmail, dropdown-list import, …)
 * and pass the merged map to <RealtimeNotificationsListener handlers={...} />.
 */
export const baseRealtimeHandlers = {
  ...bulkDeleteHandlers,
  ...bulkRestoreHandlers,
  ...importHandlers,
  ...exportHandlers
};
